module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-results-filters-collapse-box collapse in"
  }, [_c('div', {
    staticClass: "ibox-results-filters"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Load Reference or Location")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "..."
    },
    on: {
      "input": _vm.updateKeywords
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Rego")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "..."
    },
    on: {
      "input": _vm.updateRegistration
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "options": _vm.statusOptions,
      "name": "status"
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Sort by")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "options": _vm.sortByOptions,
      "name": "sort"
    },
    model: {
      value: (_vm.sort),
      callback: function($$v) {
        _vm.sort = $$v
      },
      expression: "sort"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-load-breakdown"
  }, [_vm._l((_vm.loads), function(load) {
    return _c('load-check-list-item', {
      key: load.id,
      attrs: {
        "load": load
      }
    })
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveNoLoadChecks),
      expression: "haveNoLoadChecks"
    }],
    staticClass: "text-center text-muted"
  }, [_c('strong', [_vm._v("There are no loads.")])])], 2)]), _vm._v(" "), _c('lazy-loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveLoadChecks),
      expression: "haveLoadChecks"
    }],
    ref: "lazyLoading",
    attrs: {
      "reached-bottom": _vm.getLoadChecksForNextPage,
      "filters": _vm.filters
    }
  }, [_c('strong', {
    staticClass: "text-muted",
    slot: "finished"
  }, [_vm._v("There are no more loads.")])]), _vm._v(" "), (_vm.haveLoad) ? _c('load-check-modal') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "ibox-results-collapse visible-xs",
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "href": ".ibox-results-filters-collapse-box",
      "aria-expanded": "false",
      "aria-controls": "ibox-results-filters-collapse-box"
    }
  }, [_vm._v("\n    Show Filters "), _c('i', {
    staticClass: "fa fa-bars"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-074a201a"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loads/LoadChecksList.vue
// module id = 924
// module chunks = 0